import React from "react";
import FileSvg from "./../../Public/assets/file.svg";
import { Button } from "./../../Components/ui/button.jsx";
import { useNavigate } from "react-router-dom";

const FAQSupportComponent = () => {
  const navigate = useNavigate();
  return (
    <div className="mx-6 mb-[72px] lg:!mx-40 bg-greyShade p-4 md:px-7  rounded-lg shadow-sm flex justify-between items-center ">
      <div>
        <h2 className="text-xl  text-blackShade leading-[20px] sm:text-2xl font-geomanistBold mb-[6px] lg:mb-2">
          Questions? We're here to help.
        </h2>
        <p className="text-greyish mb-[17px] font-geomanistRegular  text-[12px] leading-[12px]">
          Browse through our FAQs or reach out to talk
        </p>
        <div className="space-x-4">
          <Button
            className="w-auto py-[10px] px-[20px]"
            onClick={() => {
              window.open(
                "https://borderlesssofttechprivatelimited.zohodesk.in/portal/en/kb/borderless-multicurrency-account",
                "_blank"
              );
            }}
            // className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition"
          >
            FAQs
          </Button>
          <Button
            variant="outline"
            className="w-auto"
            onClick={() => {
              navigate("/contact");
            }}
            // className="bg-white text-blue-600 px-4 py-2 rounded-md border border-blue-600 hover:bg-blue-50 transition"
          >
            Contact Support
          </Button>
        </div>
      </div>
      <div className="hidden md:block">
        <img
          src={FileSvg}
          alt="file"
          width={167}
          height={154}
          // size={100} className="text-blue-600"
        />
      </div>
    </div>
  );
};

export default FAQSupportComponent;
